export enum TypeMethodSendingAtpveEnum {
  UniqueFile = 1,
  FrontAndBackFiles,
}
